import React, { useState } from "react";
import { homeList } from "utils/menulist";
import { useLocation, useNavigate, matchPath } from "react-router-dom";
import {
  Button,
  List,
  ListItemButton,
  ListItemIcon,
  useMediaQuery,
} from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import PlusIcon from "assets/images/svg-icons/whitePlusIcon.svg";
import DriveCreateMenu from "../DriveCreateMenu";
import HelpAndFeedbackModal from "../HelpAndFeedbackModal";
import { openCenterModal } from "store/slices/CenterModal.slice";

const HomeSidebarContent = ({ onMenuClick }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { driveData } = useSelector((state) => state.folders);

  const folderRouteMatch = matchPath("/drive/folder/:id", location.pathname);
  const routeFolderId = folderRouteMatch?.params?.id;
  const isViewOnly =
    driveData?.folder?.permission === "view" &&
    driveData?.folder?.id === routeFolderId;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const dispatch = useDispatch();
  const hasSharedEmail = Boolean(
    driveData?.folder?.parent_owner?.email ||
    driveData?.folder?.shared_by?.email,
  );
  const isSmDown = useMediaQuery("(max-width:899px)");
  return (
    <>
      {/* New button */}
      <Button
        variant="blueContained"
        onClick={handleClick}

        startIcon={
          <MuiBox sx={{ height: "20px", width: "20px", display: "flex" }}>
            <img src={PlusIcon} alt="plus icon" className="img-full" />
          </MuiBox>
        }
        sx={{
          p: "8px 16px",
          fontWeight: "400",
        }}
      >
        {t("sidebar.new")}
      </Button>
      <DriveCreateMenu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        isViewOnly={isViewOnly}
      />

      {/* List */}
      <List sx={{ display: "flex", flexDirection: "column", gap: "8px", p: 0 }}>
        {homeList({ t })
          .filter((item) => {
            if (item.slug === "helpFeedback" || item.slug === "settings") {
              return isSmDown;
            }

            return true;
          })
          .map((item) => {
            const isActive =
              (item.slug === "mydrive"
                ? location.pathname.includes("mydrive")
                : location.pathname.includes(item.slug)) ||
              (!hasSharedEmail &&
                location.pathname.startsWith("/drive/folder/") &&
                item.slug === "mydrive") ||
              (hasSharedEmail &&
                location.pathname.startsWith("/drive/folder/") &&
                item.slug === "sharedwithme");

            return (
              <ListItemButton
                key={item.slug}
                onClick={() => {
                  if (item.slug === "helpFeedback") {
                    dispatch(
                      openCenterModal({
                        content: <HelpAndFeedbackModal />,
                        maxWidth: "840px",
                      }),
                    );
                    onMenuClick?.();
                    return;
                  }

                  if (item.slug === "settings") {
                    navigate("settings/editProfile");
                    onMenuClick?.();
                    return;
                  }

                  navigate(`/drive/${item.slug}`);
                  onMenuClick?.();
                }}
                sx={{
                  p: "8px 12px",
                  borderRadius: "8px",
                  color: isActive ? "text.white" : "text.lightgray",
                  bgcolor: isActive ? "primary.dark" : "transparent",
                  "&:hover": {
                    bgcolor: isActive
                      ? "primary.dark"
                      : "background.white",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "text.white" : "text.lightgray",
                    minWidth: "30px",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {/* <ListItemText primary={item.label} /> */}
                <MuiTypography variant="14">{item.label}</MuiTypography>
              </ListItemButton>
            );
          })}
      </List>
    </>
  );
};

export default HomeSidebarContent;
